<template>
  <v-dialog
      class="AttachDialog"
      :value="dialog"
      persistent
      max-width="1000"
      @click:outside="$emit('close')"
  >
    <v-card class="AttachDialog__card">
      <v-card-title class="text-h5"> Attach URL </v-card-title>
      <v-col>
        <v-row class="AttachDialog__file_settings">
          <v-text-field
              outlined
              dense
              label="URL"
              v-model="url"
          >
          </v-text-field>
        </v-row>
        <v-row>
          <v-text-field
              outlined
              dense
              label="Attachment Name"
              v-model="name"
          >
          </v-text-field>
        </v-row>
      </v-col>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')"> Cancel </v-btn>
        <v-btn text color="primary" @click="createKnowledge"> Add </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import lodashGet from 'lodash/get';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: workspacesGetters, mapActions: workspacesActions } =
    createNamespacedHelpers('aiWorkspace');

export default {
  name: 'AttachURL',
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      url: '',
      name: '',
    };
  },
  computed: {
    ...workspacesGetters({
      workspace: 'WORKSPACE',
    }),
  },
  methods: {
    ...workspacesActions(['addWorkspaceKnowledge']),
    isShAdmin() {
      return lodashGet(this.customer, 'customer_id') === 0;
    },
    async createKnowledge() {
      await this.addWorkspaceKnowledge({
        workspaceId: this.workspace.id,
        name: this.name,
        mimeType: 'text/html',
        externalLocation: this.url,
        type: 'url',
        isExternal: true,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './index';
</style>
